import React, { useState } from "react";
import {
    Avatar,
    Box,
    Divider,
    IconButton,
    ListItemIcon,
    Menu,
    MenuItem,
    Typography,
    ListSubheader,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import SettingsIcon from "@mui/icons-material/Settings";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import BusinessIcon from "@mui/icons-material/Business";
import PersonIcon from "@mui/icons-material/Person";
import { useNavigate } from "react-router-dom";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

export default function UserMenu({
    userProfile,
    currentContext,
    availableContexts,
    onSwitchContext,
    onProfile,
    onLogout,
}) {
    const navigate = useNavigate();
    const [anchorEl, setAnchorEl] = useState(null);
    const open = Boolean(anchorEl);
    const [errorMsg, setErrorMsg] = useState("");

    // Fallback de datos para desarrollo
    const user = userProfile || {
        displayName: "Asef López",
        companyName: "Capivio S.L.",
        role: "ADMIN",
    };
    const context = currentContext || "Capivio S.L.";
    const contexts = availableContexts || [
        { name: "Capivio S.L.", type: "empresa" },
        { name: "Usuario Particular", type: "particular" },
    ];

    return (
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
            <Typography variant="body2" sx={{ color: "#155263", fontWeight: 600 }}>
                {user.displayName} – {context}
            </Typography>
            <IconButton onClick={e => setAnchorEl(e.currentTarget)}>
                <Avatar sx={{ bgcolor: "#155263" }}>
                    {user.displayName?.[0]?.toUpperCase() || "U"}
                </Avatar>
            </IconButton>
            <Menu
                anchorEl={anchorEl}
                open={open}
                onClose={() => setAnchorEl(null)}
                PaperProps={{
                    sx: { minWidth: 260, p: 1 },
                }}
            >
                <Box sx={{ px: 2, py: 1 }}>
                    <Typography fontWeight={700}>{user.displayName}</Typography>
                    <Typography variant="body2" color="text.secondary">
            Empresa: {user.companyName}
                    </Typography>
                    <Typography variant="caption" color="primary">
                        {user.role}
                    </Typography>
                </Box>
                <Divider />
                <ListSubheader sx={{ fontSize: 13, color: "text.secondary", bgcolor: "inherit" }}>
          Cambiar de contexto
                </ListSubheader>
                {contexts.map((ctx) => (
                    <MenuItem
                        key={ctx.name}
                        selected={ctx.name === context}
                        onClick={async () => {
                            setAnchorEl(null);
                            if (ctx.name !== context) {
                                try {
                                    await onSwitchContext?.(ctx);
                                } catch (err) {
                                    setErrorMsg("Error al cambiar de contexto: " + (err?.message || "Error desconocido"));
                                }
                            }
                        }}
                    >
                        <ListItemIcon>
                            {ctx.type === "empresa" ? <BusinessIcon fontSize="small" /> : <PersonIcon fontSize="small" />}
                        </ListItemIcon>
                        {ctx.name}
                        {ctx.name === context && (
                            <Typography variant="caption" color="primary" sx={{ ml: 1 }}>
                (actual)
                            </Typography>
                        )}
                    </MenuItem>
                ))}
                <Divider />
                <MenuItem onClick={() => { setAnchorEl(null); onProfile?.(); }}>
                    <ListItemIcon>
                        <AccountCircleIcon fontSize="small" />
                    </ListItemIcon>
          Mi Perfil
                </MenuItem>
                <MenuItem onClick={() => { setAnchorEl(null); navigate("/settings"); }}>
                    <ListItemIcon>
                        <SettingsIcon fontSize="small" />
                    </ListItemIcon>
          Configuración
                </MenuItem>
                {/* Sección de configuración avanzada */}
                {/*
                <MenuItem
                    onClick={() => { setAnchorEl(null); onOffboarding?.(); }}
                    sx={{ color: "error.main", pl: 4 }}
                >
                    <ListItemIcon>
                        <DeleteForeverIcon fontSize="small" color="error" />
                    </ListItemIcon>
          Offboarding / Cerrar cuenta
                </MenuItem>
                */}
                <Divider />
                <MenuItem onClick={() => { setAnchorEl(null); onLogout?.(); }}>
                    <ListItemIcon>
                        <LogoutIcon fontSize="small" />
                    </ListItemIcon>
          Cerrar Sesión
                </MenuItem>
                <Snackbar
                    open={!!errorMsg}
                    autoHideDuration={5000}
                    onClose={() => setErrorMsg("")}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                >
                    <Alert severity="error" onClose={() => setErrorMsg("")}>{errorMsg}</Alert>
                </Snackbar>
            </Menu>
        </Box>
    );
} 